export const error = state => state.error
export const isLoading = state => state.isLoading
export const violations = state => state.violations
export const sent = state => state.sent
